import editIcon from '@disy/cadenza-icons/edit.svg';
import { on } from '@disy/lib/event-util';
import { icon } from '@disy/lib/icon';
import { logger } from '@disy/lib/logging';

import { Modal } from 'ui/dialog/modal/modal';

import type { WorkbookVersionDto } from 'cadenza/api-client/dto/workbook-version-dto';
import { updateVersionComment } from 'cadenza/api-client/workbook-api';
import type { RepositoryName } from 'cadenza/repository/model/repository-name.gen';
import type { WorkbookName } from 'cadenza/repository/model/workbook-name.gen';
import { WorkbookMetadataForm } from 'cadenza/workbook-version/workbook-metadata-form';

import i18n from './edit-version-dialog.properties';

export function openVersionDialog(
  workbookName: WorkbookName,
  repositoryName: RepositoryName,
  version: WorkbookVersionDto,
): Promise<unknown> {
  return new Modal<boolean>({
    titleIcon: icon(editIcon),
    title: i18n('title'),
    submitButton: i18n('save'),
    cancelButton: true,
    content: (modal) => createForm(workbookName, repositoryName, version, modal),
  }).connectAndShow();
}

function createForm(
  workbookName: WorkbookName,
  repositoryName: RepositoryName,
  version: WorkbookVersionDto,
  modal: Modal<boolean>,
): Promise<Node> {
  const form = new WorkbookMetadataForm(version);
  on(modal, 'submit', () => {
    const apiPromise = updateVersionComment(workbookName, repositoryName, version.version!, form.comment)
      .then(() => modal.close(true))
      .catch((error) => {
        logger.error('Error in backend request to edit version comment', error);
        modal.setAlert(i18n('form.edit.error.title'), i18n('form.edit.error.message'), 'error');
      });
    modal.setLoading(apiPromise, i18n('modal.savingVersionComment'));
  });
  return Promise.resolve(form);
}
